import "./styles.css";
import Editor from "./Editor";

export default function RichTextEditorLexical({
  jsonTextEditor,
  setJsonTextEditor,
  rawHtmlTextEditor,
  setRawHtmlTextEditor,
  setPlainTextEditor,
  resetTextEditorRef,
  error,
  autoFocus,
  isNotificationEditor
}) {
  return (
    <div className="App">
      <Editor
        jsonTextEditor={jsonTextEditor}
        setJsonTextEditor={setJsonTextEditor}
        rawHtmlTextEditor={rawHtmlTextEditor}
        setRawHtmlTextEditor={setRawHtmlTextEditor}
        setPlainTextEditor={setPlainTextEditor}
        resetTextEditorRef={resetTextEditorRef}
        error={error}
        autoFocus={autoFocus}
        isNotificationEditor={isNotificationEditor}
      />
    </div>
  );
}
